import {
  ChangeDetectionStrategy,
  Component,
  computed,
  effect,
  inject,
  input,
} from '@angular/core';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { Store } from '@ngrx/store';
import { PermanentTagCardComponent } from '../../ui-components/permanent-tags/permanent-tag-card/permanent-tag-card.component';
import { StaticActions } from '../../../store/static/+state/static.actions';
import {
  WalletKind,
  WalletLike,
  getWalletKind,
  walletKindMap,
} from '../../../data/walletKind';

/**
 * Labels a wallet as Personal / Team / Agency from its owner and permanent
 * tags, and lists the team names for team wallets.
 */
@Component({
  selector: 'app-wallet-kind-badge',
  standalone: true,
  imports: [FaIconComponent, PermanentTagCardComponent],
  templateUrl: './wallet-kind-badge.component.html',
  styleUrl: './wallet-kind-badge.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class WalletKindBadgeComponent {
  /** @deprecated Direct NgRx Store usage is deprecated. Use API endpoints instead. */
  private store = inject(Store);

  account = input<WalletLike | null | undefined>();
  small = input(false);
  /** Hide the team tag names and show only the kind badge */
  hideTags = input(false);

  WalletKind = WalletKind;
  walletKindMap = walletKindMap;

  kind = computed(() => getWalletKind(this.account()));

  kindInfo = computed(() => {
    const kind = this.kind();
    return kind ? walletKindMap[kind] : undefined;
  });

  teamTagIds = computed(() => {
    if (this.kind() !== WalletKind.TEAM || this.hideTags()) return [];
    return this.account()?.permanentTags?.list ?? [];
  });

  constructor() {
    // Team names resolve from the owning agency's static tags; make sure
    // they are loaded even when the viewer is an agent (the sidebar only
    // loads tags for agency-side users).
    effect(() => {
      const ownerId = this.account()?.owner?.id;
      if (this.teamTagIds().length && ownerId) {
        this.store.dispatch(StaticActions.loadStaticTags({ agencyId: ownerId }));
      }
    });
  }
}
